import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { LocalStorageService } from './local-storage.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { CookieService } from 'ngx-cookie';
import { environment } from './../../environments/environment';
import { Tenant } from './../models/tenant';

@Injectable()
export class TenantService {

  public API_URL: string = environment.apiUrl;

  constructor(
    private localStorage: LocalStorageService,
    private cookieService: CookieService,
    private http: Http
  ) {}

  public tenantAtual(): Tenant{
    let tenant = this.localStorage.getObject('tenantAtual') as Tenant;
    if(!tenant){
      tenant = this.cookieService.getObject('tenantAtual') as Tenant;
    }
    return tenant;
  }

  public getTenantPorCodigo(tenantCodigo: string): Observable<Tenant> {
    return this.http.get(this.API_URL+"Tenants/"+tenantCodigo)
                    .map(
                      response => response.json(),
                      error => error.json()
                    )
  }

  public obterTenantPorId(id: number): Observable<Tenant>{
    return this.http.get(`${this.API_URL}Tenants/${id}`)
                    .map(
                      response => response.json(),
                      error => error.json()
                    )
  }

  public getApi(): string{
    return this.API_URL;
  }

}



// WEBPACK FOOTER //
// ./src/app/app-services/tenant.service.ts